import { HttpContextToken, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from "@angular/core";
import { finalize, Observable } from 'rxjs';
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';

import { LoadingService } from '@services/loading.service';
import { LoadingComponent } from '@components/loading/loading.component';

/** Requisição em segundo plano (ex: miniaturas de fotos) que não deve abrir o overlay de carregamento,
 * que bloqueia a tela. */
export const SEM_LOADING = new HttpContextToken<boolean>(() => false);

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {

    constructor(
        public loadingService: LoadingService,
        private overlay: Overlay
        ) 
    { }

    private overlayRef: OverlayRef;
    private activeRequests = 0;

    intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        if (req.context.get(SEM_LOADING)) return next.handle(req);

        this.activeRequests++;
        this.show();

        return next.handle(req).pipe(finalize(() => {
            this.activeRequests--;
            if (this.activeRequests === 0) this.hide();
        }));
    }


    private show(): void {
        if (this.overlayRef?.hasAttached()) return;

        this.overlayRef = this.overlay.create({
        positionStrategy: this.overlay.position().global().centerHorizontally().centerVertically(),
        hasBackdrop: true,
        });

        this.overlayRef.attach(new ComponentPortal(LoadingComponent));
    }

    private hide(): void {
        this.overlayRef?.dispose();
    }
}